export default "__VITE_ASSET__BltzBYCe__"